export default "__VITE_ASSET__DmhDVCsi__"